import { useApiClient } from '@hooks'
import { useEffect, useState } from 'react'
import { IApplicationVersion, SubmittedApplicationApiClient } from 'api'

export default function useApplicationVersions(
    referenceId: string | undefined,
    dealerId: number | undefined) {
    const submittedApplicationApiClient = useApiClient(x => new SubmittedApplicationApiClient(x))
    const [applicationVersions, setApplicationVersions] = useState<IApplicationVersion[]>()
    const [loading, setLoading] = useState(false)

    useEffect(() => {
        if(referenceId === undefined){
            return
        }

        setLoading(true)
        submittedApplicationApiClient.versions(dealerId!, referenceId)
            .then(x => setApplicationVersions(x!))
            .finally(() => setLoading(false))
        }, [])


    return [ applicationVersions, loading ] as [ IApplicationVersion[] | undefined, boolean ]
}